// ProductDetailComponent.jsx
import React, {useEffect, useState} from "react";
import {
    Alert,
    AppBar,
    Box,
    Breadcrumbs,
    Button,
    Chip,
    IconButton,
    Paper,
    Skeleton,
    Snackbar, Toolbar as ToolbarMui,
    Toolbar,
    Typography,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ShareIcon from "@mui/icons-material/Share";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {Link, useNavigate} from "react-router-dom";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {BasketComponent} from "./BasketComponent";

/* ---------- ابزار کمکی ---------- */
const formatPrice = (val) => Number(val).toLocaleString();

/* ---------- کامپوننت اصلی ---------- */
export default function ProductDetailComponent({id}) {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [copied, setCopied] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarType, setSnackbarType] = useState("success");
    const [updateBasket, setUpdateBasket] = useState(0); // optional
    /* ---------- واکشی داده ---------- */
    useEffect(() => {
        if (!id) return;
        let alive = true;

        fetch(`${BASE_URL_API}product/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("pwa_token")}`,
                "Content-Type": "application/json",
            },
        })
            .then((r) => r.json())
            .then((json) => alive && json.code === 200 && setData(json.data))
            .catch(console.error)
            .finally(() => alive && setLoading(false));

        return () => (alive = false);
    }, [id]);

    /* ---------- اشتراک ---------- */
    const handleShare = () => {
        navigator.clipboard.writeText(window.location.href).then(() => setCopied(true));
    };

    /* ---------- لودینگ ---------- */
    if (loading)
        return (
            <Box sx={{p: 3}}>
                <Skeleton variant="rectangular" height={220}/>
                <Skeleton variant="text" height={32} sx={{mt: 2}}/>
                <Skeleton variant="text" width="40%"/>
                <Skeleton variant="text" width="60%"/>
            </Box>
        );

    if (!data) return <p style={{padding: 16}}>محصول پیدا نشد.</p>;

    /* ---------- داده‌ها ---------- */
    const {
        step,
        title,
        price,
        del_price,
        barcode,
        des,
        pictures,
        category,
        markets,
    } = data;

    const hasDiscount = Number(del_price) > 0;
    const finalPrice = hasDiscount ? price - del_price : price;

    const onAddToCardClicked = () => {
        const findCardShop = CardShopRepository.getItem(id);

        const showSnackbar = (message, type = "success") => {
            setSnackbarMessage(message);
            setSnackbarType(type);
            setOpenSnackbar(true);
        };

        if (findCardShop) {
            const totalEntity = parseInt(findCardShop.count);

            if (totalEntity < parseInt(step)) {
                if (price > 0) {
                    CardShopRepository.addCardShop(data);
                    showSnackbar("کالا با موفقیت به سبد خرید اضافه شد.");
                    setUpdateBasket(Math.random());
                } else {
                    showSnackbar("جهت خرید کالا تماس بگیرید.", "error");
                }
            } else {
                showSnackbar("موجودی کالا به اتمام رسیده!", "error");
            }
        } else if (step > 0) {
            if (price > 0) {
                CardShopRepository.addCardShop(data);
                setUpdateBasket(Math.random());
                showSnackbar("کالا با موفقیت به سبد خرید اضافه شد.");
            } else {
                showSnackbar("جهت خرید کالا تماس بگیرید.", "error");
            }
        } else {
            showSnackbar("موجودی کالا به اتمام رسیده!", "error");
        }
    };

    return (
        <>
            {/* نوار بالای صفحه */}
            <AppBar
                position="fixed"
                elevation={0}
                sx={{background: "rgba(238,238,238,0.3)", backdropFilter: "blur(6px)"}}
            >
                <Toolbar>
                    <IconButton onClick={() => navigate(-1)} size="large">
                        <ArrowBackIosNewIcon sx={{color: "black"}}/>
                    </IconButton>

                    <Typography sx={{flexGrow: 1, fontWeight: 600, color: "black"}} noWrap>
                        {title}
                    </Typography>

                    <IconButton onClick={handleShare} size="large">
                        <ShareIcon sx={{color: "black"}}/>
                    </IconButton>

                    <IconButton size="large">
                        <BasketComponent />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* محتوای اصلی */}
            <Box sx={{pt: 10, pb: 12, px: 2, direction: "rtl"}}>
                {/* اسلایدر تصاویر */}
                {pictures?.length ? (
                    <Box sx={{borderRadius: 2, overflow: "hidden", mb: 2}}>
                        <AliceCarousel
                            autoPlay
                            infinite={pictures.length > 1}
                            autoPlayInterval={3500}
                            animationDuration={800}
                            disableButtonsControls
                            disableDotsControls={pictures.length === 1}
                        >
                            {pictures.map((pic, idx) => (
                                <Box key={idx} sx={{height: 220, display: "flex", justifyContent: "center"}}>
                                    <img
                                        src={`${PRODUCT_BASE_URL_API}${pic.url}`}
                                        alt={`pic-${idx}`}
                                        style={{
                                            maxHeight: "100%",
                                            width: "100%",
                                            objectFit: "contain",
                                        }}
                                    />
                                </Box>
                            ))}
                        </AliceCarousel>
                    </Box>
                ) : (
                    <Paper
                        sx={{
                            height: 220,
                            borderRadius: 2,
                            backgroundImage: `url(/hamekara-logo.png)`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            mb: 2,
                        }}
                    />
                )}

                {/* عنوان و قیمت */}
                <Typography variant="h6" sx={{mt: 1, fontWeight: 700}}>
                    {title}
                </Typography>

                {hasDiscount && (
                    <Typography
                        variant="body2"
                        sx={{textDecoration: "line-through", color: "text.disabled"}}
                    >
                        {formatPrice(price)} تومان
                    </Typography>
                )}

                <Typography variant="h5" sx={{color: "green", fontWeight: 700, my: 0.5}}>
                    {formatPrice(finalPrice)} تومان
                </Typography>

                {/* توضیحات */}
                {des && (
                    <Typography variant="body2" sx={{mt: 1, whiteSpace: "pre-line"}}>
                        {des}
                    </Typography>
                )}

                {/* دسته‌بندی */}
                <Breadcrumbs sx={{my: 2}}>
                    {category?.parent?.title && (
                        <Chip
                            label={category.parent.title}
                            size="small"
                            component={Link}
                            to={`/category?id=${category.parent.id}`}
                            clickable
                            sx={{backgroundColor: "#FF1744", color: "#fff"}}
                        />
                    )}
                    {category?.title && (
                        <Chip
                            label={category.title}
                            size="small"
                            component={Link}
                            to={`/category?id=${category.id}`}
                            clickable
                            sx={{backgroundColor: "#FF1744", color: "#fff"}}
                        />
                    )}
                </Breadcrumbs>

                {/* اطلاعات فروشگاه */}
                {markets && (
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            border: "1px solid rgba(0,0,0,0.1)",
                            borderRadius: 2,
                            mt: 3,
                        }}
                    >
                        <Typography variant="subtitle1" fontWeight={600}>
                            {markets.name}
                        </Typography>

                        <Box sx={{display: "flex", alignItems: "center", mt: 1}}>
                            <RoomOutlinedIcon fontSize="small" sx={{ml: 0.5}}/>
                            <Typography variant="caption">{markets.address}</Typography>
                        </Box>

                        <Box sx={{display: "flex", alignItems: "center", mt: 1}}>
                            <PhoneIphoneOutlinedIcon fontSize="small" sx={{ml: 0.5}}/>
                            <Typography variant="caption">{markets.tell}</Typography>
                        </Box>

                        {markets.whatsapp && markets.whatsapp !== "none" && (
                            <Button
                                variant="outlined"
                                startIcon={<WhatsAppIcon/>}
                                size="small"
                                sx={{mt: 1}}
                                href={`https://wa.me/${markets.whatsapp}`}
                                target="_blank"
                            >
                                واتساپ
                            </Button>
                        )}
                    </Paper>
                )}

                {/* بارکد */}
                {barcode && (
                    <Typography
                        variant="caption"
                        sx={{mt: 2, display: "block", color: "text.disabled"}}
                    >
                        بارکد: {barcode}
                    </Typography>
                )}
            </Box>

            {/* نوار پایین */}
            <Box
                sx={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    p: 1,
                    backdropFilter: "blur(10px)",
                    background: "rgba(255,255,255,0.8)",
                    borderTop: "1px solid rgba(0,0,0,0.1)",
                }}
            >
                <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    sx={{borderRadius: 2, backgroundColor: "#FF1744"}}
                    onClick={onAddToCardClicked}
                    startIcon={<ShoppingBasketOutlinedIcon/>}
                >
                    افزودن به سبد
                </Button>
            </Box>

            {/* Snackbar اشتراک */}
            <Snackbar
                open={copied}
                autoHideDuration={2000}
                onClose={() => setCopied(false)}
                anchorOrigin={{vertical: "top", horizontal: "center"}}
            >
                <Alert severity="success" variant="filled">
                    لینک محصول کپی شد!
                </Alert>
            </Snackbar>


            <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setOpenSnackbar(false)}
                    severity={snackbarType}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
}
